import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  meta: {}
}

export default createCrudModule({
  client: api.client,
  resource: 'projects',
  urlRoot: '/projects',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  state
});